import { Alert } from '@mui/material';
import { ReactElement } from 'react';
import { useGalleryContext } from '.';
import type { DisplayedFile } from './filesStore';

const previewNoticeSx = { borderRadius: 0 };

function previewNoticeSelector(file: DisplayedFile | undefined): string | undefined {
  return file?.previewNotice;
}

/** The shown file's warning above it, e.g. that a linked version is outdated (PT-7117). */
export function PreviewNotice(): ReactElement | null {
  const [previewNotice] = useGalleryContext().useMainDisplayedFile(previewNoticeSelector);
  return previewNotice ? (
    <Alert severity='warning' sx={previewNoticeSx} data-qa='gallery-preview-notice'>
      {previewNotice}
    </Alert>
  ) : null;
}
